// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1__f49c9baa624906566859","cls2":"CreateSocialItemModal-cls2__d60825969f50269b655e CreateSocialItemModal-cls1__f49c9baa624906566859"};